import { render, staticRenderFns } from "./document-body.vue?vue&type=template&id=7cc93a96&scoped=true&"
import script from "./document-body.vue?vue&type=script&lang=js&"
export * from "./document-body.vue?vue&type=script&lang=js&"
import style0 from "./document-body.vue?vue&type=style&index=0&id=7cc93a96&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc93a96",
  null
  
)

export default component.exports